import { Table, Container, Button, Row, Col, Input } from 'reactstrap';
import React, { useState, useEffect } from 'react';
// import pdfFonts from "pdfmake/build/vfs_fonts";
// import pdfMake from "pdfmake/build/pdfmake";
import { NumberWithCommas } from "../../share/NumberWithCommas";
import { RiFileExcel2Line } from 'react-icons/ri'
import { AiOutlineFilePdf } from 'react-icons/ai'
import './Reports.css'
// pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';

export function Report194() {
    // pdfMake.fonts = {
    //     THSarabunNew: {
    //         normal: 'THSarabunNew.ttf',
    //         bold: 'THSarabunNew Bold.ttf',
    //         italics: 'THSarabunNew Italic.ttf',
    //         bolditalics: 'THSarabunNew BoldItalic.ttf'
    //     },
    //     Roboto: {
    //         normal: 'Roboto-Regular.ttf',
    //         bold: 'Roboto-Medium.ttf',
    //         italics: 'Roboto-Italic.ttf',
    //         bolditalics: 'Roboto-MediumItalic.ttf'
    //     }
    // }

    // const [Borrow194data, setBorrow194data] = useState([]);

    const [thYearSelected, setThYearSelected] = React.useState(new Date().getFullYear() + 543)
    const [othYearSelected, setOThYearSelected] = React.useState(new Date().getFullYear() + 543)
    const [Re194data, setRe194data] = useState([]);
    const [date194data, setdate194data] = useState([{ updateDate: '' }]);


    async function getR194() {
        const formData = new FormData();
        formData.append("thYear", thYearSelected);
        formData.append("othYear", othYearSelected);
        const res194 = await fetch("/api/BorrowReports/getV194", {
            method: 'POST',
            body: formData
        })
        const Re194data = await res194.json()
        setRe194data(Re194data.dataenum)
        console.log(Re194data)
    }

    async function getdate() {
        const resdate194 = await fetch("/api/BorrowReports/getdateV194")
        const date194data = await resdate194.json();
        setdate194data(date194data.dataenum)
        console.log(date194data)
    }

    const [Re194yeardata, setRe194yeardata] = React.useState([]);

    async function getR194year() {
        const res = await fetch("/api/BorrowReports/getyear194")
        const Re194yeardata = await res.json()
        setRe194yeardata(Re194yeardata.dataenum)
        console.log(Re194yeardata)
    }

    const y2 = Re194yeardata.filter(n => n.yearTh >= othYearSelected);

    useEffect(() => {
        getR194()
        getdate()
        getR194year()
    }, [thYearSelected, othYearSelected]);

    let sum1 = Re194data.reduce(function (prev, current) {
        return prev + +current.amountLimit
    }, 0);
    let sum2 = Re194data.reduce(function (prev, current) {
        return prev + +current.companyNo
    }, 0);
    let sum3 = Re194data.reduce(function (prev, current) {
        return prev + +current.amountApprove
    }, 0);
    let sum4 = Re194data.reduce(function (prev, current) {
        return (sum3 * 100) / sum1
    }, 0);
    let sum5 = Re194data.reduce(function (prev, current) {
        return prev + +current.sum
    }, 0);

    let sum6 = Re194data.reduce(function (prev, current) {
        return (sum5 * 100) / sum1
    }, 0);

    let sum7 = Re194data.reduce(function (prev, current) {
        return prev + +current.companyNo1
    }, 0);
    let sum8 = Re194data.reduce(function (prev, current) {
        return prev + +current.amountContact
    }, 0);
    let sum9 = Re194data.reduce(function (prev, current) {
        return (sum3 * 100) / sum1
    }, 0);
    let sum10 = Re194data.reduce(function (prev, current) {
        return prev + +current.sum1
    }, 0);
    let sum11 = Re194data.reduce(function (prev, current) {
        return (sum5 * 100) / sum1
    }, 0);

    

    const chartdata = Re194data.map((item) => ({
        name: "ปีงบประมาณ"+ " " + item.year,
        amountApprove : item.amountApprove,
        amountContact : item.amountContact,
      }));
      
    //   console.log(chartdata);
      
    
    return (
        <Container>

            <div className='d-flex justify-content-center align-items-center'>
                <span className='header-select-year mx-3'>ข้อมูลปีงบประมาณ</span>
                <Input
                    // className='report-select-year'
                    className="rounded-pill input-color w-25 text-center"
                    id="othYear"
                    name="othYear"
                    type="select"
                    value={othYearSelected}
                    onChange={(e) => {
                        setOThYearSelected(e.target.value)
                    }}
                >
                    {Re194yeardata.map((item, i) => (
                        <option value={item.yearTh}>
                            {item.yearTh}
                        </option>

                    ))}

                </Input>
                <span className='header-select-year mx-3'>ถึง</span>
                <Input
                    // className='report-select-year'
                    className="rounded-pill input-color w-25 text-center"
                    id="thYear"
                    name="thYear"
                    type="select"
                    value={thYearSelected}
                    onChange={(e) => {
                        setThYearSelected(e.target.value)
                    }}
                >
                    {y2.map((item, i) => (
                        <option value={item.yearTh}>
                            {item.yearTh}
                        </option>

                    ))}
                </Input>
            </div>

            <Row className='my-3'>
                <Col className='d-flex justify-content-end'>
                    <Button className="btn border border-1 mx-1 btn-green" href={`api/BorrowReports/xlsxV194?thYear=${thYearSelected}&othYear=${othYearSelected}`} download><RiFileExcel2Line /> Export Excel</Button>
                    <Button className="btn border border-1 mx-1 btn-red" href={`api/BorrowReports/pdfR194?thYear=${thYearSelected}&othYear=${othYearSelected}`} download><AiOutlineFilePdf /> Export PDF</Button>
                </Col>
            </Row>

            <div className="report-wrapper">
                <Table className="styled-table text-center" bordered striped hover>
                    <thead className='styles-thead'>
                        <tr>
                            <th rowSpan="2" className='text-center'>
                                ปีงบประมาณ
                            </th>
                            <th rowSpan="2" className='text-center'>
                                วงเงินให้กู้
                            </th>


                            <th colSpan="5" className=' text-center'>
                                อนุมัติเงินกู้ยืม (ต.ค. {othYearSelected - 1} - ก.ย. {thYearSelected} )
                            </th>
                            <th colSpan="5" className=' text-center'>
                                ทำสัญญา (ต.ค. {othYearSelected - 1} - ก.ย. {thYearSelected} )
                            </th>

                        </tr>
                        <tr>
                            <th className='text-center'>
                                บริษัท
                            </th>
                            <th className='text-center'>
                                วงเงินอนุมัติ
                            </th>
                            <th className='text-center'>
                                ร้อยละ
                            </th>
                            <th className='text-center'>
                                คงเหลืองบประมาณจากอนุมัติ
                            </th>
                            <th className='text-center'>
                                ร้อยละ
                            </th>
                            <th className='text-center'>
                                บริษัท
                            </th>
                            <th className='text-center'>
                                วงเงินทำสัญญา
                            </th>
                            <th className='text-center'>
                                ร้อยละ
                            </th>
                            <th className='text-center'>
                                คงเหลืองบประมาณจากทำสัญญา
                            </th>
                            <th className='text-center'>
                                ร้อยละ
                            </th>

                        </tr>
                    </thead>
                    <tbody>
                        {Re194data?.map((item, i) => (
                            <tr >
                                <td className='text-start'>
                                    ปีงบประมาณ {item.year}
                                </td>
                                <td className='text-end'>
                                    {NumberWithCommas(item.amountLimit)}
                                </td>
                                <td className='text-end'>
                                    {item.companyNo}
                                </td>
                                <td className='text-end'>
                                    {NumberWithCommas(item.amountApprove)}
                                </td>
                                <td className='text-end'>
                                    {item.per.toFixed(2)}%
                                </td>
                                <td className='text-end'>
                                    {NumberWithCommas(item.sum)}
                                </td>

                                <td className='text-end'>
                                    {item.per1.toFixed(2)}%
                                </td>
                                <td className='text-end'>
                                    {item.companyNo1}
                                </td>
                                <td className='text-end'>
                                    {NumberWithCommas(item.amountContact)}
                                </td>
                                <td className='text-end'>
                                    {item.per2.toFixed(2)}%
                                </td>
                                <td className='text-end'>
                                    {NumberWithCommas(item.sum1)}
                                </td>
                                <td className='text-end'>
                                    {item.per3.toFixed(2)}%
                                </td>

                            </tr>

                        )) || <tr><td colSpan="9" rowSpan="6" className='text-center'>ไม่มีข้อมูลในระบบ</td></tr>}
                    </tbody>
                    <tfoot>
                        <tr>
                            <th scope="row" className='text-end'>
                                รวมทั้งสิ้น
                            </th>
                            <td className='text-end'>
                                {NumberWithCommas(sum1)}
                            </td>
                            <td className='text-end'>
                                {sum2}
                            </td>
                            <td className='text-end'>
                                {NumberWithCommas(sum3)}
                            </td>
                            <td className='text-end'>
                                {sum4.toFixed(2)}%
                            </td>
                            <td className='text-end'>
                                {NumberWithCommas(sum5)}
                            </td>
                            <td className='text-end'>
                                {sum6.toFixed(2)}%
                            </td>
                            <td className='text-end'>
                                {sum7}
                            </td>
                            <td className='text-end'>
                                {NumberWithCommas(sum8)}
                            </td>
                            <td className='text-end'>
                                {sum9.toFixed(2)}%
                            </td>
                            <td className='text-end'>
                                {NumberWithCommas(sum10)}
                            </td>
                            <td className='text-end'>
                                {sum11.toFixed(2)}%
                            </td>
                        </tr>
                    </tfoot>
                </Table>
            </div>

            <div className='mt-5 w-100 d-flex align-items-center justify-content-center'>
                <BarChart
                    width={1300}
                    height={300}
                    data={chartdata}
                    margin={{
                        top: 5,
                        right: 30,
                        left: 20,
                        bottom: 5,
                    }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Bar name="วงเงินอนุมัติ" dataKey="amountApprove" fill="#0A72FF" />
                    <Bar name="วงเงินทำสัญญา" dataKey="amountContact" fill="#0AB1FF" />
                </BarChart>
            </div>

            <tr className=' d-flex justify-content-end'>
                ข้อมูล ณ วันที่ {date194data.updateDate}
            </tr>
        </Container>
    );
}